export enum ConductStatuses {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Complete = "COMPLETE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}
